import { BudgetType, RunningPattern } from 'core/rtbCampaign/singlePage/common';
import { useFormik } from 'formik';

interface useDateManagetProps {
  defaultForm: any;
  values: ReturnType<typeof useFormik>['values'];
  setFieldValue: ReturnType<typeof useFormik>['setFieldValue'];
  handleResetAllBudget: () => void;
}

const useDateManaget = (
  initialState: useDateManagetProps = {
    defaultForm: {},
    values: {},
    setFieldValue: async () => Promise.resolve(),
    handleResetAllBudget: () => {},
  },
) => {
  const { setFieldValue, handleResetAllBudget } = initialState;

  // 切換廣告期間
  const handleDurationChange = async (runningPattern) => {
    const durationBugetTypeMap = {
      [RunningPattern.UNLIMITED]: [BudgetType.DAILY],
      [RunningPattern.LIMITED]: [BudgetType.DAILY, BudgetType.TOTAL],
    };
    setFieldValue('basic.runningPattern', runningPattern);
    setFieldValue('basic.budgetTypes', durationBugetTypeMap[runningPattern]);
    if (runningPattern === RunningPattern.UNLIMITED) {
      setFieldValue('basic.budgetType', BudgetType.DAILY);
    }
    handleResetAllBudget();
  };

  // 變更活動區間
  const handleDateRangeChange = (startDate, endDate) => {
    setFieldValue('basic.startDate', startDate);
    setFieldValue('basic.endDate', endDate);
  };

  const handleChangeStartDate = (startDate) => {
    setFieldValue('basic.startDate', startDate);
  };

  const handleChangeEndDate = (endDate) => {
    setFieldValue('basic.endDate', endDate);
  };

  return {
    handleDurationChange,
    handleDateRangeChange,
    handleChangeStartDate,
    handleChangeEndDate,
  };
};

export default useDateManaget;
